import { instance } from "../index";

/**
 * Fetch QR code by ID
 * @param {string} qrCodeId - The QR code ID
 * @returns {Promise} Response data
 */
export const getQRCodeById = async (qrCodeId) => {
  try {
    const response = await instance.get(`/api/web/qrcode/${qrCodeId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
